import toast from "react-hot-toast";
import {
  SvgToastInfo,
  SvgToastSuccessful,
  SvgAlertPeopleType,
  SvgAlertVehicleType,
  SvgAlertNonMotorVehicleType,
  SvgAlertConflagrationType,
  SvgAlertSmokingType,
} from "ui/svgs";
import clsx from "clsx";
import {
  personKey,
  vehicleKey,
  onMotorVehicleKey,
  smokingKey,
  conflagrationKey,
} from "lib/constants";
import { forwardRef } from "react";
import ReactPhoneInput from "react-phone-input-2";
const shownMessages = new Set();

export function showToast(
  type: number,
  text: string,
  {
    minWidth = 500,
    duration = 1500,
  }: { minWidth?: number; duration?: number } = {},
) {
  if (!text) {
    return;
  }
  // filter duplicate messages
  if (shownMessages.has(text)) {
    return;
  }
  shownMessages.add(text);
  setTimeout(() => {
    shownMessages.delete(text);
  }, duration);

  switch (type) {
    case 0:
      toast(text, {
        style: { minWidth: minWidth, wordBreak: "break-all" },
        duration: duration,
        icon: (
          <SvgToastSuccessful width="16" className="fill-white flex-shrink-0" />
        ),
      });
      break;
    case 1:
      console.error(text);
      toast(text, {
        style: {
          minWidth: minWidth,
          background: " #FFEDEB",
          color: "#F73D2F",
          fontWeight: 600,
          wordBreak: "break-all",
        },
        duration: duration,
        icon: (
          <SvgToastInfo width="16" className="fill-[#F73D2F]  flex-shrink-0" />
        ),
      });
      break;
    default:
      break;
  }
}

export function getAlertIcon(
  type: string,
  enabled: boolean = true,
  fillColor: string = "fill-zinc-500",
) {
  switch (type) {
    case personKey:
      return (
        <SvgAlertPeopleType
          width="18"
          className={clsx(fillColor || "fill-zinc-500", {
            "opacity-25": !enabled,
          })}
        />
      );
    case vehicleKey:
      return (
        <SvgAlertVehicleType
          width="18"
          className={clsx(fillColor || "fill-zinc-500", {
            "opacity-25": !enabled,
          })}
        />
      );
    case onMotorVehicleKey:
      return (
        <SvgAlertNonMotorVehicleType
          width="18"
          className={clsx(fillColor || "fill-zinc-500", {
            "opacity-25": !enabled,
          })}
        />
      );
    case smokingKey:
      return (
        <SvgAlertSmokingType
          width="18"
          className={clsx(fillColor || "fill-zinc-500", {
            "opacity-25": !enabled,
          })}
        />
      );
    case conflagrationKey:
      return (
        <SvgAlertConflagrationType
          width="18"
          className={clsx(fillColor || "fill-zinc-500", {
            "opacity-25": !enabled,
          })}
        />
      );
  }
}

export const PhoneInput = forwardRef(function PhoneInput(props: any, ref: any) {
  const { onChange, value, defealtCountry, style } = props;
  //const [phoneCountry, setPhoneCountry] = useState<string>();

  return (
    <ReactPhoneInput
      placeholder="Phone number"
      country={defealtCountry || "us"}
      value={value || ""}
      onChange={(phone, countryData) => {
        console.log("ReactPhoneInput:", phone);
        onChange?.((phone.startsWith("+") ? "" : "+") + phone);
      }}
      containerClass="h-full rounded-2xl !border-[#BDBDBD]"
      inputClass="h-full rounded-2xl !border-[#BDBDBD]"
      inputStyle={{
        height: "100%",
        borderRadius: style?.borderRadius || 0,
        width: "100%",
      }}
      containerStyle={{
        height: "100%",
        borderRadius: style?.borderRadius || 0,
        width: "100%",
      }}
      buttonStyle={{
        height: "100%",
        borderTopLeftRadius: style?.borderRadius || 0,
        borderBottomLeftRadius: style?.borderRadius || 0,
      }}
    />
  );
});
